import { z } from "zod";

const SkillSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().optional().nullable().describe("Tenant ID. Null if global."),
    
    name: z.string().min(1, "Skill name is required.").regex(/^[a-zA-Z0-9_]+$/, "Name can only contain letters, numbers, and underscores."),
    description: z.string().min(1, "Description is required for semantic discovery."),
    
    engineType: z.enum(['StandardSkillEngine', 'ComputerControlEngine']).default('StandardSkillEngine'),
    
    engineConfig: z.object({
        llm: z.string().optional().describe("Specific LLM to use, overrides default."),
        maxTurns: z.number().int().positive().default(15),
        temperature: z.number().min(0).max(2).default(0.7),
    }).default({ maxTurns: 15, temperature: 0.7 }),
    
    promptTemplate: z.string().min(1, "Prompt template is required."),
    
    allowedTools: z.array(z.string()).default([]).describe("List of tool names this skill is allowed to use."),
    
    isGlobal: z.boolean().default(false).describe("If true, stored in Index DB and available to all tenants."),
    
    // Internal fields not directly edited by users
    _source: z.enum(['file', 'db', 'indexdb']).optional().default('db'),
    
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional()
});

export default SkillSchema;